import { Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper } from '@mui/material';
import { alpha, Theme } from '@mui/system';
import { FixedSizeList, ListChildComponentProps } from 'react-window';
import { stripHtmlAndConvertParagraphs } from '../../../../utils/common';
import { OnlyFansTaggedFriends } from '../../../common/OnlyFansTagCreatorsSelector';

interface Props {
    sortedTaggedFriends: OnlyFansTaggedFriends.Item[];
    taggedCreators: { id: number; name: string }[];
    handleListItemClicked: (id: number) => void;
    theme: Theme;
    disabled?: boolean;
    /** Ids rendered as an indeterminate (tri-state) checkbox, e.g. a tag only some of the targets carry */
    indeterminateIds?: Set<number>;
}

const MessageUsersTagCreatorsList = (props: Props) => {
    const { sortedTaggedFriends, taggedCreators, handleListItemClicked, theme, disabled, indeterminateIds } = props;

    const Row = ({ index, style }: ListChildComponentProps) => {
        const item = sortedTaggedFriends[index];
        const checked = taggedCreators && taggedCreators.find(taggedCreator => taggedCreator.id === item.id) ? true : false;
        const indeterminate = !checked && !!indeterminateIds?.has(item.id);

        return (
            <ListItem
                style={style}
                disablePadding
                key={item.id}
                sx={{
                    backgroundColor: checked
                        ? alpha(theme.palette.info.main, 0.2)
                        : indeterminate
                        ? alpha(theme.palette.info.main, 0.08)
                        : '',
                }}
            >
                <ListItemButton
                    role={undefined}
                    dense
                    disabled={disabled}
                    disableRipple={disabled}
                    onClick={() => {
                        if (!disabled) {
                            handleListItemClicked(item.id);
                        }
                    }}
                >
                    <ListItemIcon>
                        <Checkbox tabIndex={-1} disableRipple checked={checked} indeterminate={indeterminate} disabled={disabled} />
                    </ListItemIcon>
                    <ListItemText primary={stripHtmlAndConvertParagraphs(item.name)} secondary={`@${item.user.username}`} />
                </ListItemButton>
            </ListItem>
        );
    };

    return (
        <Paper variant="outlined" sx={{ height: 200, overflow: 'auto', width: '100%', backgroundColor: 'transparent' }}>
            <FixedSizeList height={200} width="100%" itemSize={57} itemCount={sortedTaggedFriends.length} itemData={sortedTaggedFriends}>
                {Row}
            </FixedSizeList>
        </Paper>
    );
};

export default MessageUsersTagCreatorsList;
